import React, { Component } from "react";
import "./topics.css";
import "../home/home.css";
import topics from "./topics.json";
import Navbar from "../navbar/navbar";
import ml from "../../images/ml.png";
import nlp from "../../images/nlp.png";
import iot from "../../images/iot.png";
import comm from "../../images/comm.png";
import quantum1 from "../../images/quantum1.png";
import quantum2 from "../../images/quantum2.png";
import cog from "../../images/cog.png";
import shield from "../../images/shield.png";
import sigal from "../../images/sigal.png";
import soft from "../../images/soft.png";
import ham from "../../images/ham.png";
class Topics extends Component {
	render() {
		return (
			<React.Fragment>
				<div className="header-area">
					<div id="home" className="contact-header-area  bg_cover">
						<Navbar />
						<div className=" d-flex align-items-center">
							<div className="container">
								<div className="row justify-content-center">
									<div className="col-lg-10">
										<div className="header-content text-center">
											<h2 className="header-title2">TRACKS</h2>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="topics-section">
					<div className="row justify-content-center">
						<div className="col-sm-12 col-md-4 col-lg-2 topic-col">
							<img src={soft} alt="" className="topic-image" />
							<p>Soft Computing</p>
						</div>
						<div className="col-sm-12 col-md-4 col-lg-2 topic-col">
							<img src={quantum1} alt="" className="topic-image" />
							<p>Big Data Analytics</p>
						</div>
						<div className="col-sm-12 col-md-4 col-lg-2 topic-col">
							<img src={quantum2} alt="" className="topic-image" />
							<p>Quantum Computing</p>
						</div>
						<div className="col-sm-12 col-md-4 col-lg-2 topic-col">
							<img src={ml} alt="" className="topic-image" />
							<p>Augmented Reality </p>
						</div>

						<div className="col-sm-12 col-md-4 col-lg-2 topic-col">
							<img src={iot} alt="" className="topic-image" />
							<p>Internet of Things</p>
						</div>
						<div className="col-sm-12 col-md-4 col-lg-2 topic-col">
							<img src={sigal} alt="" className="topic-image" />
							<p>MIMO systems </p>
						</div>
						<div className="col-sm-12 col-md-4 col-lg-2 topic-col">
							<img src={nlp} alt="" className="topic-image" />
							<p>Brain Computer Interface </p>
						</div>

						<div className="col-sm-12 col-md-4 col-lg-2 topic-col">
							<img src={ham} alt="" className="topic-image" />
							<p> Human Machine Interaction</p>
						</div>
						<div className="col-sm-12 col-md-4 col-lg-2 topic-col">
							<img src={comm} alt="" className="topic-image" />
							<p>Deep Learning </p>
						</div>
						<div className="col-sm-12 col-md-4 col-lg-2 topic-col">
							<img src={cog} alt="" className="topic-image" />
							<p>Cloud Computing</p>
						</div>
					</div>
				</div>
				<table className="topics-table container">
					<tr className="topics-table-header-row">
						<th colspan="2">Topics of the Conference but not limited to</th>
					</tr>
					{topics &&
						topics.map((topic, key) => (
							<tr className="topics-table-row" key={key}>
								<td className="topics-title topic-number">{`${key + 1} .`}</td>
								<td className="topics-title">{topic}</td>
							</tr>
						))}
				</table>
			</React.Fragment>
		);
	}
}
export default Topics;
